'use strict';
define(['signin/signin', '../../public/css/mcda-drugis.css'], function (
  signinModule
) {
  signinModule.initialize();
});
